import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { switchClass } from "@wm/core";
import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler, getNavClass } from "@wm/components-base";
import {WmsTranscludeDirective} from "../wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'app-right-panel';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-right-panel',
  hostClass: DEFAULT_CLS
};

@Component({
  selector: '[wmRightPanel]',
  template: `
    <div class="app-ng-transclude" wmsTransclude page-container-target>
      @if (isInlineContent) {
        <ng-content></ng-content>
      }
    </div>
        `,
  providers: [
    provideAsWidgetRef(RightPanelComponent)
  ],
  exportAs: 'wmRightPanel',
  standalone: true,
  imports: [CommonModule, WmsTranscludeDirective],
  styles: []
})
export class RightPanelComponent extends StylableComponent {
  static initializeProps = register('wm-right-panel');

  protected  isInlineContent:boolean = true;
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'columnwidth') {
      switchClass(this.nativeElement, `col-sm-${nv}`, ov ? ` col-sm-${ov}` : '');
    }
    if (key === 'navtype') {
      this.$element.addClass(getNavClass(nv));
      this.$element.removeClass(getNavClass(ov));
    }
    else {
      super.onPropertyChange(key, nv, ov);
    }
  }

}

